import { createAction, handleActions } from 'redux-actions'
import api from '../api'
import * as globalMessageActions from '../global-message'

const GET_PAGE_TEXTS = createAction('page-texts/GET_PAGE_TEXTS')
const GET_PAGE_TEXTS_SUCCESS = createAction('page-texts/GET_PAGE_TEXTS_SUCCESS')

const GET_PAGE_TEXT = createAction('page-texts/GET_PAGE_TEXT')
const GET_PAGE_TEXT_SUCCESS = createAction('page-texts/GET_PAGE_TEXT_SUCCESS')

const CREATE_PAGE_TEXT = createAction('page-texts/CREATE_PAGE_TEXT')
const CREATE_PAGE_TEXT_SUCCESS = createAction('page-texts/CREATE_PAGE_TEXT_SUCCESS')

const EDIT_PAGE_TEXT = createAction('page-texts/EDIT_PAGE_TEXT')
const EDIT_PAGE_TEXT_SUCCESS = createAction('page-texts/EDIT_PAGE_TEXT_SUCCESS')

const DELETE_PAGE_TEXTS = createAction('page-texts/DELETE_PAGE_TEXTS')
const DELETE_PAGE_TEXTS_SUCCESS = createAction('page-texts/DELETE_PAGE_TEXTS_SUCCESS')

const SET_ACTIVE = createAction('page-texts/SET_ACTIVE')
const RESET_ACTIVE = createAction('page-texts/RESET_ACTIVE')
const UPDATE_ACTIVE = createAction('page-texts/UPDATE_ACTIVE')

const SET_NEW = createAction('page-texts/SET_NEW')
const RESET_NEW = createAction('page-texts/RESET_NEW')

const SET_ERROR = createAction('page-texts/SET_ERROR')

const SELECT_ITEM = createAction('page-texts/SELECT_ITEM')
const UNSELECT_ITEM = createAction('page-texts/UNSELECT_ITEM')
const UNSELECT_ALL = createAction('page-texts/UNSELECT_ALL')
const TOGGLE_ALL = createAction('page-texts/TOGGLE_ALL')

const SET_PAGE = createAction('page-texts/SET_PAGE')
const SET_ROWS_PER_PAGE = createAction('page-texts/SET_ROWS_PER_PAGE')

const SET_SORT = createAction('page-texts/SET_SORT')
const SET_FILTER = createAction('page-texts/SET_FILTER')

const CLEAR_PAGETEXTS = createAction('page-texts/CLEAR_PAGETEXTS')

const languageMapping = {
  "sv": "Swedish",
  "fi": "Finnish",
  "en": "English"
}

const initialState = {
  items: [],
  item: {},
  selectedItems: [],
  itemCount: 0,
  allSelected: false,
  active: null,
  new: false,
  loading: false,
  sort: { orderBy: 'pageName', direction: 'asc' },
  filter: { country: '', productType: '' },
  rowsPerPage: 25,
  page: 0
}

export default handleActions(
  {
    [GET_PAGE_TEXTS]: (state, action) => ({
      ...state,
      loading: true,
      items: [],
      itemCount: 0
    }),
    [GET_PAGE_TEXTS_SUCCESS]: (state, action) => {
      action.payload.forEach(function (e) {
        e.checked = false
      })
      return {
        ...state,
        loading: false,
        items: action.payload,
        itemCount: action.payload.length
      }
    },
    [GET_PAGE_TEXT]: (state, action) => ({
      ...state,
      loading: true
    }),
    [GET_PAGE_TEXT_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      item: action.payload
    }),
    [CREATE_PAGE_TEXT]: (state, action) => ({
      ...state,
      loading: true
    }),
    [CREATE_PAGE_TEXT_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [EDIT_PAGE_TEXT]: (state, action) => ({
      ...state,
      loading: true
    }),
    [EDIT_PAGE_TEXT_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [DELETE_PAGE_TEXTS]: (state, action) => ({
      ...state,
      loading: true
    }),
    [DELETE_PAGE_TEXTS_SUCCESS]: (state, action) => ({
      ...state,
      loading: false
    }),
    [SET_ERROR]: (state, action) => ({
      ...state,
      loading: false
    }),
    [SELECT_ITEM]: (state, action) => {
      var selectedItem = state.items.find(i => i.id === action.payload.id)
      selectedItem.checked = true
      state.selectedItems.push({ ...selectedItem })
      var all = state.items && state.selectedItems ? state.items.length === state.selectedItems.length : false

      return {
        ...state,
        items: state.items,
        selectedItems: state.selectedItems,
        allSelected: all
      }
    },
    [UNSELECT_ITEM]: (state, action) => {
      var selectedItem = state.items.find(i => i.id === action.payload.id)
      selectedItem.checked = false
      var selectedItems = state.selectedItems.filter(function (element) {
        return element.id !== selectedItem.id
      })
      return {
        ...state,
        items: state.items,
        selectedItems: selectedItems,
        allSelected: false
      }
    },
    [UNSELECT_ALL]: (state, action) => ({
      ...state,
      selectedItems: [],
      allSelected: false
    }),
    [TOGGLE_ALL]: (state, action) => {
      var checked = !action.payload
      state.items.forEach(function (item) {
        item.checked = checked
      })
      return {
        ...state,
        items: state.items,
        selectedItems: checked ? [...state.items] : [],
        allSelected: checked
      }
    },
    [SET_ACTIVE]: (state, action) => ({
      ...state,
      active: { ...action.payload }
    }),
    [RESET_ACTIVE]: (state, action) => ({
      ...state,
      active: null
    }),
    [UPDATE_ACTIVE]: (state, action) => {
      var active = state.active
      active[action.payload.name] = action.payload.value
      return { ...state, active: active }
    },
    [SET_NEW]: (state, action) => ({
      ...state,
      active: action.payload,
      new: true
    }),
    [RESET_NEW]: (state, action) => ({
      ...state,
      active: null,
      new: false
    }),
    [SET_PAGE]: (state, action) => ({
      ...state,
      page: action.payload
    }),
    [SET_ROWS_PER_PAGE]: (state, action) => ({
      ...state,
      rowsPerPage: action.payload
    }),
    [SET_SORT]: (state, action) => ({
      ...state,
      sort: { orderBy: action.payload, direction: state.sort.direction === 'asc' ? 'desc' : 'asc' }
    }),
    [SET_FILTER]: (state, action) => {
      let filter = state.filter
      filter[action.payload.name] = action.payload.value
      return { ...state, filter: filter }
    },
    [CLEAR_PAGETEXTS]: (state, action) => ({
      ...state,
      items: []
    })
  },
  initialState
)

export const getPageTexts = (searchText = '') => {
  return (dispatch, getState) => {
    dispatch(GET_PAGE_TEXTS())
    return api
      .get('pagetexts/getPageTexts', '', `searchText=${searchText}`)
      .then(result => {
        dispatch(GET_PAGE_TEXTS_SUCCESS(result.pageTexts))
      })
      .catch(error => {
        dispatch(SET_ERROR())
        // global message
      })
  }
}

export const getPageText = (pageName, country, language) => {
  return dispatch => {
    dispatch(GET_PAGE_TEXT())
    return api
      .get('pagetexts/getPageText', '', `pageName=${pageName}&country=${country}&language=${languageMapping[language]}`)
      .then(result => {
        dispatch(GET_PAGE_TEXT_SUCCESS(result))
      })
      .catch(error => {
        dispatch(SET_ERROR())
        // global message
      })
  }
}

export const createPageText = pageText => {
  return dispatch => {
    dispatch(CREATE_PAGE_TEXT())
    return api
      .post('pagetexts/createPageText', '', pageText)
      .then(result => {
        dispatch(CREATE_PAGE_TEXT_SUCCESS(result))
        dispatch(getPageTexts())
        dispatch(resetNew())
      })
      .catch(error => {
        dispatch(SET_ERROR())
        dispatch(resetNew())
        dispatch(globalMessageActions.setGlobalError('Failed to create page text'))
      })
  }
}

export const editPageText = pageText => {
  return dispatch => {
    dispatch(EDIT_PAGE_TEXT())
    return api
      .post('pagetexts/updatePageText', pageText.id, pageText)
      .then(result => {
        dispatch(EDIT_PAGE_TEXT_SUCCESS(result))
        dispatch(getPageTexts())
        dispatch(resetActive())
      })
      .catch(error => {
        dispatch(SET_ERROR())
        dispatch(globalMessageActions.setGlobalError('Failed to update page text'))
      })
  }
}

export const deleteItems = pageTexts => {
  return (dispatch, getState) => {
    const pageTextIds = getState().pageTexts.selectedItems.map(p => p.id)
    dispatch(DELETE_PAGE_TEXTS())
    return api
      .post('pagetexts/deletePageTexts', '', { pageTextIds: pageTextIds })
      .then(result => {
        dispatch(DELETE_PAGE_TEXTS_SUCCESS(result))
        dispatch(getPageTexts())
        dispatch(resetActive())
      })
      .catch(error => {
        dispatch(SET_ERROR())
        dispatch(globalMessageActions.setGlobalError('Failed to delete selected page texts'))
      })
  }
}

export const search = searchText => {
  return dispatch => {
    dispatch(getPageTexts(searchText))
  }
}

export const selectItem = item => {
  return dispatch => {
    dispatch(SELECT_ITEM(item))
  }
}

export const unselectItem = item => {
  return dispatch => {
    dispatch(UNSELECT_ITEM(item))
  }
}

export const unselectAll = () => {
  return dispatch => {
    dispatch(UNSELECT_ALL())
  }
}

export const toggleAll = checked => {
  return dispatch => {
    dispatch(TOGGLE_ALL(checked))
  }
}

export const setActive = pageText => {
  return dispatch => {
    dispatch(SET_ACTIVE(pageText))
  }
}

export const resetActive = () => {
  return dispatch => {
    dispatch(RESET_ACTIVE())
  }
}

export const updateActive = (name, value) => {
  return dispatch => {
    dispatch(UPDATE_ACTIVE({ name, value }))
  }
}

export const setNew = reset => {
  return dispatch => {
    // init a new pageText
    const pageText = {
      pageName: '',
      title: '',
      content: '',
      country: ''
    }
    dispatch(SET_NEW(pageText))
  }
}

export const resetNew = () => {
  return dispatch => {
    dispatch(RESET_NEW())
  }
}

export const setSort = value => {
  return dispatch => {
    dispatch(SET_SORT(value))
  }
}

export const setFilter = (name, value) => {
  return dispatch => {
    dispatch(SET_FILTER({ name, value }))
  }
}

export const setPage = value => {
  return dispatch => {
    dispatch(SET_PAGE(value))
  }
}

export const setRowsPerPage = value => {
  return dispatch => {
    dispatch(SET_ROWS_PER_PAGE(value))
  }
}

export const clearPageTexts = () => {
  return dispatch => {
    dispatch(CLEAR_PAGETEXTS())
  }
}



// WEBPACK FOOTER //
// ./src/store/page-texts/index.js